import { render, staticRenderFns } from "./FriendStatBox.vue?vue&type=template&id=2d6935a7&scoped=true"
import script from "./FriendStatBox.vue?vue&type=script&lang=ts"
export * from "./FriendStatBox.vue?vue&type=script&lang=ts"
import style0 from "./FriendStatBox.vue?vue&type=style&index=0&id=2d6935a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6935a7",
  null
  
)

export default component.exports